module.exports = __webpack_public_path__ + "static/media/sound.b472afef.png";